import { SVGProps } from "react";

const SearchIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 14L20 20" stroke="black" strokeWidth="1.2" />
      <circle cx="9.5" cy="9.5" r="5.9" stroke="black" strokeWidth="1.2" />
    </svg>
  );
};

export default SearchIcon;
